import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class DeedInformation extends Component {
  state = {
    rows: [],
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const rows = [];
    if (props.deed !== undefined) {
      const record = props.deed[0];
      const recs = [];
      getAllRows(record, recs, props, _.get(record, "$.display"));
      if (recs.length > 0) {
        rows.push(
          <Table.Row key={`deed_row`}>
            <Table.Cell>
              <Table>
                <Table.Body>{recs}</Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
        );
      }
    }
    this.setState({ rows });
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Deed Information"}
        rows={this.state.rows}
        defaultFold
      />
    );
  }
}

export default DeedInformation;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/DeedInformation.js